<main class="page-container">
  <section class="wizard-container">
    <header class="config-title-container">
      @if (configWizardCompleted() && !pubMethods.hasData(crmService.specificConfigWizardStep())) {
        <div class="d-flex flex-gap-1 border-bottom ml-1 pb-3">
          <div class="success-badge">
            <i class="far fa-check fa-xl"></i>
          </div>
          <div>
            <h2>
              {{crmType | titlecase}} Integration Active
            </h2>
            
            <span>Your Zint account is successfully connected and syncing with {{crmType | titlecase}}.</span>
            
          </div>
        </div>
      }
      @else {
        <h2 class="ml-4">    
          {{crmType | titlecase}} Integration
        </h2>
      }
    </header>

  @if (isLoading.isLoadingCrmConfig) {
    <zint-loader></zint-loader>
  }

  @else if (configWizardCompleted() && !pubMethods.hasData(crmService.specificConfigWizardStep())) {  
    @if (isParentSuperuser) {
      <wizard-crm-status [stepData]="configStepsData.steps"></wizard-crm-status>  
    } @else {
      <div class="my-4 d-flex flex-column flex-gap-05 align-items-center">
        <span>You have successfully authorised Zint.</span>
        <button class="rounded-btn-base rounded-btn-white btn-p-md" (click)="goToAuthStep()" matTooltip="Should you need to re-authorise">Back to Auth step</button>        
        <a href="/dashboard" class="rounded-btn-base rounded-btn-white btn-p-md text-reset">Go To Dashboard</a>        
      </div>
    }
  }

  @else {   
    <mat-stepper 
      #stepper
      [linear]="true" 
      [selectedIndex]="getCurrentStep()" 
      orientation="horizontal" 
      disableRipple 
      labelPosition="bottom" 
      [class.hide-stepper-header]="isParentSuperuser === false">

    <ng-template matStepperIcon="edit">      
      <i class="fas fa-check"></i>
    </ng-template>
    @for (step of configStepsData.steps; track $index;) {
    <mat-step [completed]="step.isCompleted"> 
      <!-- <ng-template matStepContent> -->
        <div class="wizard-step-container"> 
          @if (isParentSuperuser) {
            <h4>Step {{ $index + 1 }}: {{step.stepTypeDisplay}} <small>{{showOptionalLabel(step.stepType)}}</small></h4>
          }@else {
            <h4>{{step.stepTypeDisplay}}</h4>
          }   
          <p #stepRef class="text-grey-600">{{ step.description }}            
            <small class="text-sup" role="button" matTooltip="Help" (click)="toggleHelpModal(step.stepType)">
              <i class="fas fa-circle-info text-vivid-blue"></i>
            </small>
          </p>
            @switch (step.stepType) {
              @case ('auth') {
                <wizard-crm-auth [stepData]="step" (setStepIsReady)="updateWizardCompletedStateForNonSU($event)"></wizard-crm-auth>              
              }
              @case ('object_type') { 
                @defer (on viewport(stepRef)) {                       
                <wizard-crm-object-selector  [stepData]="step" [allSteps]="configStepsData.steps"></wizard-crm-object-selector> 
                }                                    
              }
              @case ('superuser_token') { 
                @defer (on viewport(stepRef)) {                       
                  <wizard-crm-superuser-token  [stepData]="step"></wizard-crm-superuser-token>
                }    
              }                                
              @case ('lookup_field') { 
                @defer (on viewport(stepRef)) {                       
                  <wizard-crm-lookup-field  [stepData]="step"></wizard-crm-lookup-field>
                }                                    
              }
              @case ('export_mapping') { 
                @defer (on viewport(stepRef)) {                       
                  <wizard-crm-export-mapping  [stepData]="step"></wizard-crm-export-mapping>
                }                                    
              }
              @case ('export_permissions') { 
                @defer (on viewport(stepRef)) {                       
                  <wizard-crm-permissions  [stepData]="step"></wizard-crm-permissions>
                }                                    
              }
              @case ('enrichment') { 
                @defer (on viewport(stepRef)) {                       
                  <wizard-crm-enrichment  [stepData]="step"></wizard-crm-enrichment>
                }                                    
              }
              @case ('import_config') {
                @defer (on viewport(stepRef)) {
                  <wizard-crm-import-mapping  [stepData]="step"></wizard-crm-import-mapping>
                }
              }
              @case ('company_matcher') {
                @defer (on viewport(stepRef)) {
                  <wizard-crm-company-matcher  [stepData]="step"></wizard-crm-company-matcher>
                }
              }
              @default {
                <span>A config step.</span>
              }
            }          
        </div>      
      
        @if (isParentSuperuser) {
          <div class="wizard-nav-btns-container">

            <button class="rounded-btn-base rounded-btn-white btn-p-md flex-1" matStepperPrevious *ngIf="$index > 0">Back</button>
                      
            <button class="rounded-btn-base rounded-btn-dark btn-p-md" [ngClass]="$first ? 'w-50':'flex-1'" 
            [disabled]="isNextBtnDisabled()[step.stepType]"
            (click)="setStepCompletedState(step, $index)"
            *ngIf="!$last">Next
          </button>
          
          <button *ngIf="$last" class="rounded-btn-base rounded-btn-dark btn-p-md flex-1" 
            [disabled]="isNextBtnDisabled()[step.stepType]"
            (click)="setStepCompletedState(step, $index)"
              >
              Complete Configuration
            </button>   

            @if (configWizardCompleted() && pubMethods.hasData(crmService.specificConfigWizardStep())) {
              <button *ngIf="!$last" class="rounded-btn-base rounded-btn-vivid-outline btn-p-md flex-1" [disabled]="isNextBtnDisabled()[step.stepType]"
                (click)="showSummary()">
                Show Summary
              </button>
            }
          </div>
        }
        <!-- </ng-template> -->
    </mat-step>
    }
    </mat-stepper>
  }
  </section>
</main>

@if (showHelpModal) {
  <zint-modal [modalConfig]="stepHelpModalConfig" [modalContent]="stepHelpModalContent"></zint-modal>
}